import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService, DomainDetails } from 'src/app/app.service';

import { LoaderService } from './loader-service.service';
import { LoaderState } from './loader-state';

@Component({
  selector: 'app-loader-common',
  templateUrl: './loader-common.component.html',
  styleUrls: ['./loader-common.component.scss']
})
export class LoaderCommonComponent implements OnInit, OnDestroy {
  show = false;
  private subscription: Subscription;
  constructor(
    private loaderService: LoaderService,
    public appservice: AppService,
  ) { }
  public domainDetails: DomainDetails
  ngOnInit() {
    this.subscription = this.loaderService.loaderState
      .subscribe((state: LoaderState) => {
        this.show = state.show;
      });
    this.domainDetails = this.appservice.DOMAIN_DETAILS();
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
